import React, { Component } from 'react';
import styled from '@emotion/styled';

import BackgroundImage from './img/bg-square.svg';

const Div = styled.div`
  background-color: ${props =>
    props.customColor
      ? props.theme[props.customColor]
      : props.theme.primaryColor};
  background-image: ${props =>
    props.withBackgroundImage ? 'url(' + BackgroundImage.src + ')' : null};
  background-size: 227px 227px;
  padding-top: ${props => (props.paddingTop ? props.paddingTop : '0')};
  padding-bottom: ${props => (props.paddingBottom ? props.paddingBottom : '0')};
  ${props => (props.positionRelative ? 'position: relative;' : null)}
  @media print {
    background-image: none;
  }
  ${props => (props.height ? 'height: ' + props.height + ';' : null)}
  ${props =>
    props.topInnerShadow
      ? 'box-shadow: inset 0 .5rem .5rem -.5rem ' +
        props.theme.dropShadowDarkerColor +
        ';'
      : null}
`;

class FullColoredSlice extends Component {
  render() {
    return (
      <Div
        customColor={this.props.customColor}
        withBackgroundImage={this.props.withBackgroundImage}
        paddingTop={this.props.paddingTop}
        paddingBottom={this.props.paddingBottom}
        positionRelative={this.props.positionRelative}
        height={this.props.height}
        topInnerShadow={this.props.topInnerShadow}
      >
        {this.props.children}
      </Div>
    );
  }
}

export default FullColoredSlice;
